module.exports = __webpack_public_path__ + "static/media/heart17.a4aecbae.svg";